import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-none border-2 px-2 py-0.5 text-xs font-extrabold uppercase tracking-[0.12em] transition-colors focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-1",
  {
    variants: {
      variant: {
        default:
          "border-slate-900 bg-slate-900 text-white",
        secondary:
          "border-slate-300 bg-slate-100 text-slate-800",
        destructive:
          "border-rose-400 bg-rose-50 text-rose-800",
        outline: "border-slate-400 text-slate-800 bg-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
